<template>
  <Transition name="fade">
    <div
      v-show="isContextOpen"
      ref="context"
      :style="{
        left: `${position.contextLeft}px`,
        top: `${position.contextTop}px`,
      }"
      class="table-context-menu"
    >
      <div
        v-if="isAffiliate"
        :class="{'context-tab-disabled': ($_.isEmpty(selectedRow) && selectIds.length === 0) || selectedRow.row_id === 'null'}"
        class="item"
        @click="affiliate"
      >
        <UiIcon
          class="context-icon"
          name="user"
        />
        <span>{{ $t('reports.other.affiliate_info') }}</span>
      </div>
      <div
        :class="{'context-tab-disabled': $_.isEmpty(selectedRow) && selectIds.length === 0}"
        class="item"
        @click="drilldown"
      >
        <UiIcon
          class="context-icon"
          name="random"
        />
        <span>{{ $t('reports.other.drilldown') }}</span>
      </div>
      <div
        :class="{'context-tab-disabled': $_.isEmpty(selectedRow) && selectIds.length === 0}"
        class="item"
        @click="exclude"
      >
        <UiIcon
          class="context-icon"
          name="page-break"
        />
        <span>{{ $t('reports.other.exclude') }}</span>
      </div>
      <div
        class="item"
        @click="showPlayersReport"
      >
        {{ $t('reports.other.show_player') }}
      </div>
      <!--      <div-->
      <!--        v-if="isPaymentGroup"-->
      <!--        class="item"-->
      <!--        @click="openPR( selectRows.length ? selectRows : [selectedRow])"-->
      <!--      >-->
      <!--        <span>{{ $t('reports.other.open_payment') }}</span>-->
      <!--      </div>-->
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    selectRows: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedColumn: {
      type: Object,
      default() {
        return {};
      },
    },
    selectedRow: {
      type: Object,
      default() {
        return {};
      },
    },
    selectIds: {
      type: Array,
      default() {
        return [];
      },
    },
    isContextOpen: {
      type: Boolean,
      default: false,
    },
    disableDrilldown: {
      type: Boolean,
      default: true,
    },
    isPaymentGroup: {
      type: Boolean,
      default: true,
    },
    isAffiliate: {
      type: Boolean,
      default: false,
    },
    currentReport: {
      type: Number,
      default: 0,
    },
    position: {
      type: Object,
      default() {
        return {
          contextLeft: 0,
          contextTop: 0,
        };
      },
    },
  },
  emits: ['drilldownReport', 'createReport', 'affiliate', 'showPlayersReport', 'openPR'],
  methods: {
    openPR(rows) {
      this.$emit('openPR', rows);
    },
    showPlayersReport() {
      this.$emit('showPlayersReport');
    },
    drilldown() {
      if (this.disableDrilldown || this.currentReport === 0) {
        this.$emit('createReport', null);
        return;
      }
      this.$emit('drilldownReport', '=');
    },
    affiliate() {
      this.$emit('affiliate', this.selectedRow);
    },
    exclude() {
      if (this.disableDrilldown || this.currentReport === 0) {
        this.$emit('createReport', null, '!=');
        return;
      }
      this.$emit('drilldownReport', '!=');
    },
  },
};
</script>
